'use strict';

var _ = require('lodash');
var DataExtractValidationService = function DataExtractValidationService(constants, hepService) {
  var treeGrid;
  function setTreeGrid(grid) {
    treeGrid = grid;
  }
  function findFiltersWithoutValues(rows, invalidFilters) {
    _.each(rows, function (row) {
      if (row.leaf && row.inputFilter === '') {
        invalidFilters.push(row);
      } else if (row.records) {
        findFiltersWithoutValues(row.records, invalidFilters);
      }
    });
  }
  function formatFilterNames(filters) {
    return _.map(filters, function (f) {
      return f.name;
    }).join(', ');
  }
  function markTheFirstFilter(rows) {
    treeGrid.markRowAsEdited(rows[0].uid);
  }
  function isValid(scope, newExtract) {
    if (newExtract && isExtractNameAlreadyRegistered(scope.registeredExtractNames, scope.extractConfig.extractName)) {
      scope.isSummaryVisible = true;
      scope.summaryMessage = 'Extract Name ' + scope.extractConfig.extractName + ' is already registered.';
      return false;
    }
    var invalidFilters = [];
    findFiltersWithoutValues(treeGrid.getTopLevelRows(), invalidFilters);
    if (invalidFilters.length > 0) {
      scope.isSummaryVisible = true;
      scope.summaryMessage = 'Filters have no values: ' + formatFilterNames(invalidFilters);
      markTheFirstFilter(invalidFilters);
      return false;
    }
    scope.xtForm.submit();
    if (scope.xtForm.form.$invalid) {
      scope.isSummaryVisible = true;
      scope.summaryMessage = 'Please complete all required fields.';
      return false;
    }
    if (scope.extractConfig.extractFields.length === 0) {
      scope.isSummaryVisible = true;
      scope.summaryMessage = 'Please select at least one field in Selected Fields section.';
      return false;
    }
    var extractSingleReadingDay = !!hepService.getSimpleHepProperties().EXTRACT_FORMAT_SINGLE_READING_DAY_PER_LINE;
    if (!extractSingleReadingDay && !validateMaxOneCurveSelected(scope.extractConfig)) {
      scope.isSummaryVisible = true;
      scope.summaryMessage = 'Only one curve can be selected.';
      return false;
    }
    if (!validateFileName(scope.extractConfig)) {
      scope.isSummaryVisible = true;
      scope.summaryMessage = 'Report name contains invalid characters.';
      return false;
    }
    if (!validateSchedulingSection(scope.schedulerConfig)) {
      scope.isSummaryVisible = true;
      scope.summaryMessage = 'Please fill in the schedule form.';
      return false;
    }
    scope.isSummaryVisible = false;
    return true;
  }
  function validateFileName(extractConfig) {
    var regex = new RegExp('^[\\w-_.]*$', 'g');
    return regex.test(extractConfig.fileName);
  }
  function validateMaxOneCurveSelected(extractConfig) {
    var curveCount = 0;
    _.forEach(extractConfig.extractFields, function (field) {
      if (isCurve(field)) {
        curveCount++;
      }
    });
    return curveCount <= 1;
  }
  function isCurve(field) {
    return field.processingType === constants.PROCESSING_TYPES.CURVE || field.processingType === constants.PROCESSING_TYPES.BID_PRICE;
  }
  function validateSchedulingSection(schedulerConfig) {
    return schedulerConfig.shouldRunNow() || !schedulerConfig.recurrence || validateSchedulerConfig(schedulerConfig);
  }
  function validateSchedulerConfig(schedulerConfig) {
    return validateEndingOptions(schedulerConfig) && validateRecurrenceRepeatNumber(schedulerConfig);
  }
  function validateRecurrenceRepeatNumber(schedulerConfig) {
    return schedulerConfig.calendar || schedulerConfig.recurrenceRepeatNumber;
  }
  function validateEndingOptions(schedulerConfig) {
    return validateUntilTime(schedulerConfig) && validateNumberOfRepeats(schedulerConfig);
  }
  function validateUntilTime(schedulerConfig) {
    return schedulerConfig.recurrenceRepeatOption !== constants.RECURRENCE.UNTIL || schedulerConfig.repeatUntilDate;
  }
  function validateNumberOfRepeats(schedulerConfig) {
    return schedulerConfig.recurrenceRepeatOption !== constants.RECURRENCE.TIMES || schedulerConfig.repeatTimesNumber;
  }
  function isExtractNameAlreadyRegistered(registeredNames, newExtractName) {
    return _.includes(registeredNames, newExtractName);
  }
  return {
    setTreeGrid: setTreeGrid,
    isValid: isValid
  };
};
DataExtractValidationService.$inject = ['DataExtractConstants', 'HepService'];
module.exports = DataExtractValidationService;